export const AuthShell = ({ children }) => (
  <div className="min-h-screen grid lg:grid-cols-2 bg-background">
    <div className="hidden lg:block relative">
      <img
        src="https://images.pexels.com/photos/11163176/pexels-photo-11163176.jpeg"
        alt="A peaceful, sunlit workspace"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
      <div className="absolute bottom-0 left-0 p-12">
        <p className="font-serif text-3xl text-white leading-snug max-w-md">
          “Each of you should give what you have decided in your heart to give.”
        </p>
        <p className="text-white/80 text-sm mt-3 tracking-wide">2 Corinthians 9:7</p>
      </div>
    </div>

    <div className="flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-sm fade-in">
        <h1 className="text-4xl sm:text-5xl font-serif font-semibold text-foreground">Joanna Beck</h1>
        <p className="text-sm uppercase tracking-[0.25em] text-muted-foreground mt-2">Ministries</p>
        {children}
      </div>
    </div>
  </div>
);
